import { add } from './add';
import { find } from './find';
import { remove } from './remove';
import { update } from './update';

export const resourceActions = {
  add,
  find,
  remove,
  update,
};
